import styled from "styled-components";

const Wrap = styled.div`
   text-align: center;
   max-width: 992px;
`;

const Keyword = styled.a`
   display: inline-block;
   font-weight: 400;
   font-size: 15px;
   line-height: 22px;
   color: #888888;
   padding: 0px 2px;

   &:before {
      content: "#";
   }
`;

function Keywords(props: any) {
   return (
      <Wrap className={props.className}>
         {props.keywords.map((keyword: any) => (
            <Keyword href={`https://art-map.co.kr/search/list.php?keyword=${keyword}`}>{keyword}</Keyword>
         ))}
      </Wrap>
   );
}

export default Keywords;
